import React from 'react';

import { Container, Title, Content, ContentContainer, AlertIcon } from './styles';

interface Props {
  title: string;
  content: JSX.Element | string;
}

const SimpleAlert = ({ title, content }: Props) => (
  <Container>
    <AlertIcon />

    <ContentContainer>
      <Title>{title}</Title>
      <Content>{content}</Content>
    </ContentContainer>
  </Container>
);

export default SimpleAlert;
